import React from "react";
import norequesticon from "../../../assets/images/no-request.png";
import CustomeButton from "~/components/Button";
import { REQUEST_TYPES } from "../useRequest";

const NoRequestsFound = ({
  setShowModal,
  requestType,
  heading,
  description,
}) => {
  return (
    <div className="no__request--container">
      <img src={norequesticon} />
      <p className="no__request__heading--primary">{heading}</p>
      <p>{description}</p>
      {requestType === REQUEST_TYPES.AD_HOC && (
        <CustomeButton
          label={"New Request"}
          className="access-btn"
          variant="contained"
          icon="pi pi-plus"
          iconPos="right"
          onClick={() => {
            setShowModal(true);
          }}
        />
      )}
    </div>
  );
};

export default NoRequestsFound;
